import _ from 'lodash';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
  },
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
      featureFlags: 'featureFlags',
    }),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    // isUserFlagEnabledQuickbooks() {
    //   const myEmail = _.get(this.userProfile, 'contactEmail');
    //   return this.isLtnAdmin || (myEmail && this.featureFlags.quickbooks);
    // },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/featureFlagMixin.js